/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomUiLayout.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "common/custom-ui-layout";

export class AutogenModelCustomUiLayout<RowType extends ModelRow> extends Endpoint<RowType, RowCustomUiLayoutFields> {
	constructor(ctor: RowConstructor) {
		super(AutogenUserSavedSearchEndpoint, ctor);
	}
}

export class AutogenRowCustomUiLayout extends ModelRow<RowCustomUiLayoutFields> {
	constructor() {
		super(AutogenUserSavedSearchEndpoint);
	}
}

export interface RowCustomUiLayoutFields {
	company_id: string;
	definition: string;
	id: string;
}

